export default __webpack_public_path__ + "assets/play.90da28.png";